module.exports = __webpack_public_path__ + "static/img/1.c10eae08.jpg";